import Vue from 'vue';
import store from '../../store';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const batchIngrediences = batchIngredienceTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedMaterials', { batchIngrediences, pagination });
  resolve(batchIngrediences);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('production/batch_ingredience', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/items.js